"use client";

// @ts-strict-ignore
import { keyframes } from "styled-components";

const fadeIn = keyframes`
  0% {
    opacity: 0; 
  }
  100% {
    opacity: 1;
  }
`;

const slideUp = keyframes`
  0% {
    top: 100%;
  }

  100% {
    top: 50%;
  }
`;

export const animations = {
  slideUp,
  fadeIn
};
